import type { EnrollmentStatus } from '../types/enrollment';

const ENROLLMENT_STATUS_MAP: Record<number, EnrollmentStatus> = {
  0: 'payment_selection',
  1: 'payment_pending',
  2: 'approval_pending',
  3: 'approved',
  4: 'activating',
  5: 'active',
  6: 'transferred',
  7: 'transferred_in_registration',
  8: 'canceled',
  9: 'canceled_in_registration',
  10: 'rejected',
  11: 'finished_with_pendencies',
  12: 'finished',
  13: 'finished_with_monograph',
  14: 'finished_with_certificate',
  15: 'blocked',
};

const FALLBACK_STATUS: EnrollmentStatus = 'approval_pending';

/**
 * Converte o código numérico `statusRegistration` da API para o tipo local `EnrollmentStatus`.
 *
 * @param code - Valor numérico retornado pelo campo `statusRegistration`
 * @returns Status de matrícula mapeado; retorna `'approval_pending'` para códigos desconhecidos
 */
export function mapEnrollmentStatus(code: number): EnrollmentStatus {
  return ENROLLMENT_STATUS_MAP[code] ?? FALLBACK_STATUS;
}
